'use strict';

const { h } = require('phy');
const { WithI18n, Translate } = require('@grpn/preact-l10n');

const { getCategoryLink } = require('../../support/slug-helper');

function filterMerchants(merchants) {
  return merchants.filter(({ offerCount }) => offerCount > 0);
}

function filterCategories(categories) {
  return categories.filter(({ onlineOffersCount }) => onlineOffersCount > 0);
}

function getMerchantItem(routes, { merchantName, merchantSlug, offerCount }) {
  return h(
    'li',
    h(
      'a',
      {
        href: routes.merchant.show.replace('{merchantSlug}', merchantSlug),
        title: merchantName,
        class: 'category-related-link',
      },
      [
        h('span.category-related-link-text', merchantName),
        h('span.category-related-link-count', `(${offerCount})`),
      ]
    )
  );
}

function getCategoryItem(routes, { id, onlineOffersCount }) {
  return h(
    'li',
    h(WithI18n, {}, i18n =>
      h(
        'a.category-related-link',
        getCategoryLink({
          categoryName: i18n.t(`js.modules.category.Name.${id}`),
          routes,
        }),
        [
          h(
            'span.category-related-link-text',
            i18n.t(`js.modules.category.Name.${id}`)
          ),
          h('span.category-related-link-count', `(${onlineOffersCount})`),
        ]
      )
    )
  );
}

function getRelatedMerchants({
  parentCategoryId,
  routes,
  merchants,
  isFullWidth,
}) {
  if (!merchants || !merchants.length) {
    return null;
  }

  return h('.category-related-column.category-related-border', [
    h(WithI18n, {}, i18n =>
      h(
        'p.category-related-heading',
        i18n.t('js.modules.category.RelatedMerchantsFormat', {
          0: i18n.t(`js.modules.category.Name.${parentCategoryId}`),
        })
      )
    ),
    h(
      `ul${isFullWidth ? '.category-related-list-full' : ''}`,
      merchants.map(merchant => getMerchantItem(routes, merchant))
    ),
  ]);
}

function getRelatedCategories({ routes, categories, isFullWidth }) {
  if (!categories || !categories.length) {
    return null;
  }

  return h('.category-related-column', [
    h(
      Translate,
      { tag: 'p', attrs: { class: 'category-related-heading' } },
      'js.modules.category.RelatedCategories'
    ),
    h(
      `ul${isFullWidth ? '.category-related-list-full' : ''}`,
      categories.map(category => getCategoryItem(routes, category))
    ),
  ]);
}

function CategoryRelated({
  parentCategoryId,
  merchants,
  categories,
  routes,
  isTouch,
  className = '',
}) {
  if (
    (!merchants || !merchants.length) &&
    (!categories || !categories.length)
  ) {
    return null;
  }

  const filteredMerchants = filterMerchants(merchants);
  const filteredCategories = filterCategories(categories);

  if (!filteredMerchants.length && !filteredCategories.length) {
    return null;
  }

  const isFullWidth =
    !isTouch && (!filteredMerchants.length || !filteredCategories.length);

  return h(
    `.category-related.${className}`,
    h('.category-related-inner', [
      getRelatedMerchants({
        parentCategoryId,
        routes,
        merchants: filteredMerchants,
        isFullWidth,
      }),
      getRelatedCategories({
        routes,
        categories: filteredCategories,
        isFullWidth,
      }),
    ])
  );
}

module.exports = CategoryRelated;
